import { Modal, Container } from "react-bootstrap";
import React from "react";
import { Space, Button, Row as AntRow, Col as AntCol } from "antd";
import ReactLoading from "react-loading";
import "./Modal.css";

function AddModal(props) {
  return (
    <div>
      <Modal show={props.show} onHide={props.onHide} size={props.size} centered>
        <Modal.Header />
        <Modal.Body>
          <div className="col-sm-12">
            <text className="custom-modal-body-title"> ADD {props.title} </text>
            <Container fluid className="modal-cont justify-content-center">
              {props.children}
            </Container>

            <AntRow className="mt-3 d-flex justify-content-end">
              <AntCol xs={12}>
                <AntRow className=" w-100">
                  <AntCol xs={12}>
                    <Button
                      className="button-secondary me-3 w-100"
                      onClick={props.onHide}
                    >
                      Cancel
                    </Button>
                  </AntCol>
                  <AntCol xs={12}>
                    {props.loader ? (
                      <div className="button-tertiary me-3 d-flex justify-content-center">
                        <ReactLoading
                          type="bubbles"
                          color="var(--tertiary-color)"
                          height={50}
                          width={50}
                        />
                      </div>
                    ) : (
                      <Button
                        type="primary"
                        className="button-primary w-100"
                        onClick={props.onSave}
                      >
                        Save
                      </Button>
                    )}
                  </AntCol>
                </AntRow>
              </AntCol>
            </AntRow>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

AddModal.defaultProps = {
  title: "",
  // type:"",
  size: "xl",
  show: () => {},
  onHide: () => {},
  onSave: () => {},
};

export default AddModal;
